<script>
import MsgList from './components/MsgListForHecto';
import Header from '../../components/Header';
import WebChat from './WebChat';

export default {
  name: 'WebChatForHecto',
  extends: WebChat,
  data() {
    return {
      isHectoBrand: true,
      handleVisualViewportResize: null
    };
  },
  components: {
    Header,
    MsgList
  },
  methods: {
    // new computed
    getKeyboardShowing() {
      return JSON.parse(window.localStorage.getItem('showHectoKeyboard'));
    },

    // override methods
    sendMessage(messageType) {
      if (this.loading === false) {
        try {
          if (this.$refs.hiddenInput) {
            this.$refs.hiddenInput.focus();
          }
        } catch (e) {
          console.log(e);
        }
        this.$refs.msgTextarea.focus();
        // TODO 사용자가 중간에 캐시를 초기화할 수 있기에, 메세지 전송시점마다 가져와서 전달하도록 하며
        // TODO 초기화 된 경우 모든 리스트를 초기화 하는 로직을 잊지말고 구현 할 것.
        this.loading = true;

        if (messageType === 'PHOTO' || messageType === 'VIDEO') {
          if (this.imagePath === '') {
            this.loading = false;
            return;
          }
          this.jsonContent = this.convertContent(messageType, this.imagePath);
        } else {
          if (this.message.length === 0) {
            this.loading = false;
            return;
          }
          if (this.message.length > 1000) {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>최대 1000자 까지 전송 가능 합니다</dd></dl>'
            });
            this.loading = false;
            return;
          }
          this.jsonContent = this.convertContent(messageType, this.message);
        }
        this.message = '';
        this.$http({
          method: 'POST',
          url: '/api/external/webchat/sendMessage',
          data: {
            senderUid: this.senderUid,
            chatRoomId: this.chatRoomId,
            messageType: messageType,
            content: this.jsonContent,
            scenarioTemplateCode: this.isHectoBrand
              ? JSON.parse(window.sessionStorage.getItem('SCENARIO_CHECK_DATA')) &&
                JSON.parse(window.sessionStorage.getItem('SCENARIO_CHECK_DATA'))[0]
              : null
          }
        })
          .then(
            (res) => {
              setTimeout(this.resizeMsgText, 0);
              if (res.data.data && res.data.data.url) {
                this.$mitt.emit('DialogPopup', {
                  useDialog: true,
                  message: `<dl class="txt"><dt>설문조사하기</dt><dd class="autoScroll">${res.data.data.description}</dd></dl>`,
                  getBtnCount: 2,
                  getCloseBtnName: '다음에 할래요',
                  getBtnName: '참여하기',
                  getButtonEvent: () => {
                    this.$mitt.emit('windowOpen', {
                      url: res.data.data.url,
                      target: 'urlWindow',
                      features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=no'
                    });
                  }
                });
              }

              if (res.data.code !== 0) {
                if (this.isNotAvailable(res.data)) return;
                this.$mitt.emit('DialogPopup', {
                  useDialog: true,
                  message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
                });

                if (this.isHectoBrand) {
                  this.closeChatRoomForHecto();
                }
              }
            },
            () => {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>메세지 전송 과정에서 문제가 발생하였습니다.</dd></dl>'
              });
            }
          )
          .catch((errorMsg) => {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>' + errorMsg + '</dd></dl>'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    // new methods
    setLocalStorege(data) {
      // 로컬스토리지 값 저장 (헥토일때만) (새로운 탭에서의 대응을 위해 세션 -> 로컬 스토리지로 변경.)
      window.localStorage.setItem('showHectoKeyboard', JSON.stringify(data));
    },

    // new methods
    closeChatRoomForHecto() {
      if (!this.chatRoomId) return false;
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/closeChatRoom',
        data: {
          chatRoomId: this.chatRoomId
        }
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
          });
        } else {
          if (res.data.data && res.data.data.url) {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: `<dl class="txt"><dt>설문조사하기</dt><dd class="autoScroll">${res.data.data.description}</dd></dl>`,
              getBtnCount: 2,
              getCloseBtnName: '다음에 할래요',
              getBtnName: '참여하기',
              getCloseButtonEvent: () => {
                window.localStorage.removeItem('showHectoKeyboard');
                window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
                window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
                this.isEnd = true;
              },
              getButtonEvent: () => {
                window.localStorage.removeItem('showHectoKeyboard');
                window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
                window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
                this.isEnd = true;
                this.$mitt.emit('windowOpen', {
                  url: res.data.data.url,
                  target: 'urlWindow',
                  features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=no'
                });
              }
            });
          }
        }
      });
    },

    // override methods
    updateKeyboardSubscribe(data) {
      if (data.chatRoomId === this.chatRoomId) {
        this.setChatRoomId(data.chatRoomId);
        this.showInput = data.showWebChatKeyboard;
        // 헥토이노베이션 커스텀
        if (this.isHectoBrand) {
          this.setLocalStorege(this.showInput);
        }
      }
    },

    // override methods
    openChatRoom() {
      const brandData = {
        brandKeyEncrypt: this.brandKey,
        senderUid: this.senderUid,
        type: this.channelType
      };
      const query = this.$route.query;
      let data;

      if (this.scenarioId) {
        brandData.scenarioId = this.parseBase64String(this.scenarioId);
      }
      if (this.$isSeller) {
        delete query.brandKey;
        delete query.channelType;
        delete query.scenarioId;
        data = Object.assign(brandData, query);
      } else {
        if (this.$route.query.ticketId) {
          brandData.ticketId = this.$route.query.ticketId;
        }
        delete query.brandKey;
        delete query.channelType;
        delete query.scenarioId;
        delete query.ticketId;
        const customParameters = Object.keys(query).map((d) => {
          return {
            customParameterKey: d,
            customParameterValue: query[d]
          };
        });
        data = Object.assign(brandData, {
          customParameters: customParameters
        });
      }
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/v2/openChatRoom',
        data: data
      }).then((res) => {
        if (res.data.code !== 0) {
          if (this.isNotAvailable(res.data)) return;
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
          });
          this.isEnd = true;
          return;
        }
        let data = res.data.data;

        this.messages = [];
        this.gnbs = [];
        // 헥토이노베이션 커스텀
        this.showInput = this.getKeyboardShowing() || data.showWebChatKeyboard;
        this.chatRoomId = data.chatRoomId;
        this.brandName = data.brandName;

        data.chatMessages.forEach((message) => {
          this.pushMessage(message);
        });
        this.addGnbs(data);
        this.$ga.event({
          eventCategory: this.$route.query.appId ? this.brandName + '_APP' : this.brandName,
          eventAction: this.channelType,
          eventLabel: this.senderUid
        });
        if (this.$isIframe) {
          window.parent.postMessage(
            {
              messageType: 'STATUS',
              data: data.status
            },
            '*'
          );
        } else if (window.opener) {
          window.opener.postMessage(
            {
              messageType: 'STATUS',
              data: data.status
            },
            '*'
          );
        }
      });
    }
  },
  beforeDestroy() {
    if (this.isMobile && !navigator.userAgent.indexOf('Android') > -1) {
      window.removeEventListener('resize', this.handleVisualViewportResize);
    }
  }
};
</script>
